import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { variation } from 'ember-launch-darkly';

import { MainLayout } from 'register-partners-js/react/components/layouts/main';
import { ErrorInfo } from 'register-partners-js/utils/error-info';
import { fetchKyc } from 'register-partners-js/utils/fetch-kyc';

export default class RegistrationStartRoute extends Route {
  mainLayout = MainLayout;

  @service router;
  @service segment;
  @service sentry;
  @service queryClientManager;

  async getKycInfo(legalCountry) {
    try {
      let isSingleKycEnabled = variation('feature--boolean-single-kyc');

      return await fetchKyc({
        sentry: this.sentry,
        queryClientManager: this.queryClientManager,
        isSingleKycEnabled: Boolean(isSingleKycEnabled),
        market: legalCountry,
      });
    } catch (error) {
      if (ErrorInfo.for(error).shouldSendToSentry) {
        this.sentry.captureException(error);
      }
      return null;
    }
  }

  async model() {
    let registration = this.modelFor('registration');
    let organization = registration.get('organization');
    let owner = registration.get('owner');
    let kycInfo = await this.getKycInfo(organization.get('legalCountry'));

    return {
      registration,
      organization,
      owner,
      kycInfo,
    };
  }

  activate() {
    let registration = this.modelFor('registration');
    if (registration.companyCreationFromScratch) {
      this.segment.track('onboarding_partner_overview_loaded', {
        partner_name: registration.partnerName,
        is_company_creation_from_scratch: registration.companyCreationFromScratch,
      });
    }

    return registration;
  }

  redirect(model) {
    if (model.registration.pricePlanCode && !model.registration.prepaidSource) {
      this.router.transitionTo('registration.payment');
    }
  }
}
